
import React from 'react';
import { VideoStatsGrid, VideoRoiStatsGrid } from '../StatsDisplay';
import InfoAlert from '../InfoAlert';

const StatsTab: React.FC = () => {
  return (
    <div className="mt-0 p-0">
      <InfoAlert>
        Les statistiques sont comptabilisées depuis la date initiale de publication. Du 1 mars 2023, 04:45:33 à aujourd'hui.
      </InfoAlert>
      
      <div className="p-4">
        <h3 className="text-lg font-medium mb-4">
          Statistiques Rapports <span className="text-sm font-normal text-gray-500">(Dernière mise à jour : Mar 4, 2023, 4:58:40 AM)</span>
        </h3>
        
        <VideoStatsGrid />
        
        <h3 className="text-lg font-medium mb-4">Statistiques Social Media ROI</h3>
        
        <InfoAlert action={{ text: "Ajouter un compte Google Analytics" }}>
          Obtenez plus d'informations en connectant un compte Google Analytics
        </InfoAlert>
        
        <VideoRoiStatsGrid />
      </div>
    </div>
  );
};

export default StatsTab;
